import {Component, Input} from '@angular/core';
import {Menu} from '@core/modules/layout/interfaces/menu.interface';
import {RouterService} from '@shared/services/router.service';

@Component({
  selector: 'app-menu-vertical-tree',
  templateUrl: './menu-vertical-tree.component.html',
  styleUrls: [
    '../../menu.component.scss',
    './menu-vertical-tree.component.scss'
  ]
})
export class MenuVerticalTreeComponent {
  constructor(private routerService: RouterService) {}

  @Input() nodes: Menu[] = [];
  @Input() isChild: boolean;

  onToggle(item: Menu): void {
    item.isExpanded = !item.isExpanded;
  }

  isActiveRoute(item: Menu): boolean {
    return this.routerService.isActiveRoute(item.link, !item.children);
  }
}
